// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

function DisableAll() {
    var disableSelector = "input,button,textarea,select,a.btn,a>i.icon-trash,l10n-textarea,l10n-input,l10n-editor";
    var isSkipDisabled = function (attributes) {
        for (var i = 0; i < attributes.length; i++) {
            if (attributes[i].name === "skip-disable") {
                return true;
            }
        }
        return false;
    };

    var preventDefault = function (event) {
        if (isSkipDisabled(event.target.attributes)) {
            return true;
        }
        event.stopPropagation();
        event.preventDefault();
        return false;
    };

    var disableElements = function (elements) {

        var len = elements.length;
        for (var i = 0; i < len; i++) {
            var el = elements[i];
            if (el.attributes && isSkipDisabled(el.attributes)) {
                continue;
            }
            if (!el.disabled) {
                $(el).attr('disabled', true);
               if ($(el).hasClass("icon-edit") || $(el).hasClass("icon-trash") || $(el).hasClass("btn")) {
                    $(el).hide();
                }
                if ($(el).is("l10n-textarea,l10n-input,l10n-editor")) {
                    el.addEventListener('click', preventDefault, true);
                }
            }
        }

    };

    var isNgDisabled = function (element) {
        if (!element) {
            return false;
        }
        var ngDisabledAttr = element.attributes["ng-disabled"];
        if (!ngDisabledAttr) {
            return false;
        }
        var expression = element.attributes["ng-disabled"].value;
        var scope = angular.element(element).scope();
        if (!scope){
            return false;
        }
        return scope.$eval(expression);
    };

    var enableElements = function (elements) {
        var len = elements.length;
        for (var i = 0; i < len; i++) {
            var el = elements[i];
            var ngDisabledResult = isNgDisabled(el);

            if (el.disabled === true && !ngDisabledResult) {
                el.disabled = false;
                if ($(el).is("l10n-textarea,l10n-input,l10n-editor")) {
                    el.removeEventListener('click', preventDefault, true);
                }
            }
        }
    };



    var disableAll = function (element) {
        var elemens = [];
        $(element).find(disableSelector).each(function () {
            elemens.push($(this)[0]);
        });
        disableElements(elemens);
    };

    var enableAll = function (element) {
        var elemens = [];
        $(element).find(disableSelector).each(function () {
            elemens.push($(this)[0]);
        });
        enableElements(elemens);
    };

    return {
        restrict: 'A',
        link: function (scope, element, attrs) {

            var toggleDisableAll = function (element, isDisabled) {
                isDisabled ? disableAll(element) : enableAll(element);
            };

            var disableElement = function(disabledElement) {
                var isDisabled = scope.$eval(attrs.disableAll);
                toggleDisableAll(disabledElement, isDisabled);
            };

            var disabledElement = attrs.disableElementId ? document.getElementById(attrs.disableElementId) : element[0];
            window.setTimeout(function () { disableElement(disabledElement); }, 20);

            var elementsWatch = scope.$watch(function () {
                return $(element).find(disableSelector).length;
            }, function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    disableElement(disabledElement);
                    window.setTimeout(function () { disableElement(disabledElement); }, 20);
                }
            });

            // Watch on DisableAll attribute value
            scope.$watch(
                function () {
                 return attrs.disableAll;
                }, function (isDisabled) {
                    disableElement(disabledElement);
            });

            scope.$on('$destroy', function () {
                elementsWatch();
                enableAll(disabledElement);

            });
        }
    };
};
